<template>
  <div class="m-t-0 f-11 c-gray">
    {{ $t('Active filters') }}:
    <div
      v-for="filter in filtersWithNames"
      :key="filter.value"
      class="label label-basic c-gray inline-block"
    >
      <span class="capitalize">{{ filter.type }}:</span>
      {{ filter.name }}
      <span class="pointer c-black m-l-5" @click="removeFilter(filter)">x</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: { type: Array, default: () => [] },
  },
  computed: {
    filtersWithNames() {
      return this.filters.filter((f) => !!f.name)
    },
  },
  methods: {
    removeFilter(filter) {
      this.$emit('remove-filter', filter)
    },
  },
}
</script>

<style scoped>
.label {
  padding-bottom: 0.4em;
  margin-left: 5px;
  /*text-transform: capitalize !important;*/
}
</style>
